module.exports = __webpack_public_path__ + "static/media/google.e62322ed.webp";